'use client';

import {motion} from 'framer-motion';
import BookBtn from '../buttons/BookBtn/BookBtn';
import ArrowLink from '../buttons/ArrowLink/ArrowLink';
import heroVariants from '../../animation/heroVariants';

const defaultProps = {
  title: 'More than 30 years at the intersection of',
  highlight: 'cybersecurity and innovation.',
  text: 'In that time we have seen the impact of incidents and the cost and complexity of maintaining both infrastructure and security in a rapidly evolving world. We believe there is a',
  text_highlight: 'better way.'
};

const CompanyHero = ({ title=defaultProps.title, text=defaultProps.text, highlight=defaultProps.highlight, text_highlight=defaultProps.text_highlight }) => {
  return (
    <motion.section
      className='company-hero'
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='hero-glow' aria-hidden='true'></div>
      <div className='container'>
        <h2 className='title'>
          {title}
          <span className='highlight'> {highlight}</span>
        </h2>
        <p className='text'>
          {text}
          <span className='highlight' style={{paddingLeft: '0.3em'}}>
            {text_highlight}
          </span>
        </p>
        <div className='buttons'>
          <BookBtn text='Contact us' />
          <ArrowLink text={'View the platform'} url={'platform/overview/'} />
        </div>
      </div>
    </motion.section>
  );
};
CompanyHero.defaultProps = defaultProps;
export default CompanyHero;
